import React from "react";
import useApp from "../../store/contexts/AppContext";
import RoomTeamBackgroundAndColors from "../../utils/RoomTeamColors";
import { makeStyles } from "@mui/styles"
import { RoomStyle } from "./RoomStyle";

const useStyles = makeStyles((theme) => RoomStyle(theme));

export default function RoomTeams() {
  const {
    appState: { activeChat },
  } = useApp();

  const classes = useStyles();

  return (
    <div>
      <div className={classes.textMiddle2}>
      </div>
      {activeChat?.room_teams?.length > 0 ? (
        <div>
          <div className={classes.roomTeamHeader}>
            <div className={classes.roomTeamInnerHeader}>Team name</div>
            <div className={classes.roomTeamInnerHeader}>Score</div>
          </div>
          {activeChat?.room_teams?.map((team, index) => {
            const theme = RoomTeamBackgroundAndColors[index];
            const colorStyle = {
              background: theme.backgroundColor,
              color: theme.textColor,
            };
            return (
              <div key={team.id} className={classes.roomTeamContainer}>
                <div className={classes.roomTeamName} style={{ ...colorStyle }}>
                  {team.name}
                </div>
                <div className={classes.roomTeamScore} style={{ ...colorStyle }}>{team.score}</div>
              </div>
            );
          })}
        </div>
      ) : (
        <div style={{ textAlign: "center" }}>No teams available</div>
      )}
    </div>
  );
}
